import store from '../store'
import { CHECKOUT_META } from './constants'

function createChildren(name, path) {
  return [
    {
      path: '',
      name: `${name}.start`,
      component: () => import('@/pages/CheckoutPages/layouts/Start')
    },
    {
      path: 'registration/:offerId',
      name: `${name}.register`,
      component: () => import('@/pages/CheckoutPages/layouts/Registration'),
      meta: {
        auth: false
      },
      beforeEnter(to, from, next) {
        const isaAuth = store.getters['auth/isAuthenticated']
        if (isaAuth) {
          return next(path)
        }
        next()
      }
    },
    {
      path: 'payment/:offerId',
      name: `${name}.payment`,
      component: () => import('@/pages/CheckoutPages/layouts/Payment')
    }
  ]
}

function createOnboardingChildren(type, isPaddle = false) {
  if (type === 'onboarding-70') {
    return [
      {
        path: '',
        name: `onboarding70${isPaddle ? 'New' : ''}.start`,
        component: () => import('@/pages/CheckoutPages/Onboarding/Start')
      },
      {
        path: 'registration/:offerId',
        name: `onboarding70${isPaddle ? 'New' : ''}.register`,
        component: () => import('@/pages/CheckoutPages/layouts/Registration'),
        meta: {
          auth: false
        },
        beforeEnter(to, from, next) {
          const isAuth = store.getters['auth/isAuthenticated']
          if (isAuth) {
            return next(isPaddle ? '/onboarding-70-new/' : '/onboarding-70/')
          }
          next()
        }
      },
      {
        path: 'payment/:offerId',
        name: `onboarding70${isPaddle ? 'New' : ''}.payment`,
        component: () => import('@/pages/CheckoutPages/layouts/Payment')
      }
    ]
  } else if (type === 'onboarding-12-12') {
    return [
      {
        path: '',
        name: `onboarding12${isPaddle ? 'New' : ''}.start`,
        component: () => import('@/pages/CheckoutPages/Onboarding/Start')
      },
      {
        path: 'registration/:offerId',
        name: `onboarding12${isPaddle ? 'New' : ''}.register`,
        component: () => import('@/pages/CheckoutPages/layouts/Registration'),
        meta: {
          auth: false
        },
        beforeEnter(to, from, next) {
          const isAuth = store.getters['auth/isAuthenticated']
          if (isAuth) {
            return next(
              isPaddle ? '/onboarding-12-12-new/' : '/onboarding-12-12/'
            )
          }
          next()
        }
      },
      {
        path: 'payment/:offerId',
        name: `onboarding12${isPaddle ? 'New' : ''}.payment`,
        component: () => import('@/pages/CheckoutPages/layouts/Payment')
      }
    ]
  } else if (type === 'onboarding-3-9') {
    return [
      {
        path: '',
        name: `onboarding39${isPaddle ? 'New' : ''}.start`,
        component: () => import('@/pages/CheckoutPages/Onboarding/Start')
      },
      {
        path: 'registration/:offerId',
        name: `onboarding39${isPaddle ? 'New' : ''}.register`,
        component: () => import('@/pages/CheckoutPages/layouts/Registration'),
        meta: {
          auth: false
        },
        beforeEnter(to, from, next) {
          const isAuth = store.getters['auth/isAuthenticated']
          if (isAuth) {
            return next(isPaddle ? '/onboarding-3-9-new/' : '/onboarding-3-9/')
          }
          next()
        }
      },
      {
        path: 'payment/:offerId',
        name: `onboarding39${isPaddle ? 'New' : ''}.payment`,
        component: () => import('@/pages/CheckoutPages/layouts/Payment')
      }
    ]
  }

  return [
    {
      path: '',
      name: `onboarding66${isPaddle ? 'New' : ''}.start`,
      component: () => import('@/pages/CheckoutPages/Onboarding/Start')
    },
    {
      path: 'registration/:offerId',
      name: `onboarding66${isPaddle ? 'New' : ''}.register`,
      component: () => import('@/pages/CheckoutPages/layouts/Registration'),
      meta: {
        auth: false
      },
      beforeEnter(to, from, next) {
        const isAuth = store.getters['auth/isAuthenticated']
        if (isAuth) {
          return next(isPaddle ? '/onboarding-6-6-new/' : '/onboarding-6-6/')
        }
        next()
      }
    },
    {
      path: 'payment/:offerId',
      name: `onboarding66${isPaddle ? 'New' : ''}.payment`,
      component: () => import('@/pages/CheckoutPages/layouts/Payment')
    }
  ]
}

function createUnlimitedChildren(isPaddle = false) {
  return [
    {
      path: '',
      name: isPaddle ? 'unlimitedPaddle.start' : 'unlimitedTwoCheckout.start',
      component: () => import('@/pages/CheckoutPages/UnlimitedV2/Start')
    },
    {
      path: 'registration/:offerId',
      name: isPaddle
        ? 'unlimitedPaddle.register'
        : 'unlimitedTwoCheckout.register',
      component: () => import('@/pages/CheckoutPages/UnlimitedV2/Registration'),
      meta: {
        auth: false
      },
      beforeEnter(to, from, next) {
        const isAuth = store.getters['auth/isAuthenticated']
        if (isAuth) {
          return next(isPaddle ? '/unlimited-paddle/' : '/unlimited-2checkout/')
        }
        next()
      }
    },
    {
      path: 'payment/:offerId',
      name: isPaddle
        ? 'unlimitedPaddle.payment'
        : 'unlimitedTwoCheckout.payment',
      component: () => import('@/pages/CheckoutPages/UnlimitedV2/Payment')
    }
  ]
}

export const checkouts = [
  // Checkout/v2
  {
    path: '/checkout/v2/',
    name: 'checkout.index',
    component: () => import('@/pages/Checkout/Index.vue'),
    meta: {
      premium_only: true,
      auth: true,
      type: 'regular',
      experiment_layer: 'class'
    },
    beforeEnter(to, from, next) {
      const isPremium = store.getters['account/isPremium']
      if (isPremium) {
        next('/courses')
      }
      next()
    }
  },
  {
    path: '/payment/v2/:offerId',
    name: 'payment.index',
    component: () => import('@/pages/PaymentV2/Index.vue'),
    meta: {
      premium_only: true,
      auth: true,
      type: 'regular',
      experiment_layer: 'class'
    }
  },

  // Holiday Offers
  {
    path: '/promo70/',
    name: 'checkoutHoliday.index',
    component: () => import('@/pages/CheckoutHoliday/Index.vue'),
    meta: {
      premium_only: true,
      auth: true,
      type: 'promo70',
      experiment_layer: 'class'
    },
    beforeEnter(to, from, next) {
      const isPremium = store.getters['account/isPremium']

      if (isPremium) {
        next('/courses')
      }
      next()
    }
  },
  {
    path: '/promo70/:offerId',
    name: 'holidayPayment.index',
    component: () => import('@/pages/PaymentHoliday/Index.vue'),
    meta: {
      premium_only: true,
      auth: true,
      experiment_layer: 'class',
      type: 'promo70'
    }
  },
  {
    path: '/email/promo50',
    name: 'emailPromo50.index',
    component: () => import('@/pages/CheckoutEmailPromo50/Index.vue'),
    meta: {
      premium_only: true,
      auth: true,
      type: 'email50',
      experiment_layer: 'class'
    }
  },
  {
    path: '/promo50',
    name: 'checkoutPromo50.index',
    component: () => import('@/pages/CheckoutPromo50/Index.vue'),
    meta: {
      premium_only: true,
      auth: true,
      type: 'promo50',
      experiment_layer: 'class'
    }
  },
  {
    path: '/email/promo70',
    name: 'checkoutPromo70.index',
    component: () => import('@/pages/CheckoutPromo70/Index.vue'),
    meta: {
      premium_only: true,
      auth: true,
      type: 'email70',
      experiment_layer: 'class'
    }
  },
  {
    path: '/promonotrial70',
    name: 'checkoutHolidayNotrial.index',
    component: () => import('@/pages/PromoNoTrial70/Index.vue'),
    meta: {
      premium_only: true,
      auth: true,
      type: 'promonotrial70',
      experiment_layer: 'class'
    }
  },

  {
    path: '/prices',
    name: 'prices.index',
    component: () => import('@/pages/CheckoutV4/Index.vue'),
    meta: {
      auth: false,
      type: 'external_checkout',
      experiment_layer: 'external'
    }
  },
  {
    path: '/checkout/v5',
    name: 'checkout_v5.index',
    component: () => import('@/pages/CheckoutV5/Index'),
    meta: {
      auth: false,
      type: 'external_promo_checkout',
      experiment_layer: 'class'
    }
  },
  {
    path: '/payment/v5/:offerId',
    name: 'payment_v5.index',
    component: () => import('@/pages/PaymentV5/Index'),
    meta: {
      premium_only: true,
      type: 'external_promo_checkout',
      experiment_layer: 'class'
    }
  },
  {
    path: '/registration/:offerId',
    name: 'registration.index',
    component: () => import('@/pages/Registration/Index'),
    meta: {
      auth: false
    },
    beforeEnter(to, from, next) {
      const isaAuth = store.getters['auth/isAuthenticated']
      if (isaAuth) {
        next('/checkout/v5')
      }
      next()
    }
  },
  {
    path: '/paymentday/:offerId',
    name: 'paymentDay.index',
    component: () => import('@/pages/PaymentDay/Index'),
    meta: {
      premium_only: true,
      type: 'external_promo_notrial_checkout',
      experiment_layer: 'class',
      hasTrial: false
    }
  },

  {
    path: '/unlimited-offer/',
    name: 'unlimited.index',
    component: () => import('@/pages/CheckoutPages/UnlimitedV2/Index'),
    children: [
      {
        path: '',
        name: 'unlimited.start',
        component: () => import('@/pages/CheckoutPages/UnlimitedV2/Start')
      },
      {
        path: 'registration/:offerId',
        name: 'unlimited.register',
        component: () =>
          import('@/pages/CheckoutPages/UnlimitedV2/Registration'),
        meta: {
          auth: false
        },
        beforeEnter(to, from, next) {
          const isAuth = store.getters['auth/isAuthenticated']
          if (isAuth) {
            return next('/unlimited-offer/')
          }
          next()
        }
      },
      {
        path: 'payment/:offerId',
        name: 'unlimited.payment',
        component: () => import('@/pages/CheckoutPages/UnlimitedV2/Payment')
      }
    ],
    meta: {
      type: 'external_unlimited_offer',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false
    }
  },
  {
    path: '/unlimited-2checkout/',
    name: 'unlimitedTwoCheckout.index',
    component: () => import('@/pages/CheckoutPages/UnlimitedV2/Index'),
    children: createUnlimitedChildren(),
    meta: {
      ...CHECKOUT_META.unlimited,
      type: 'external_unlimited_2checkout',
      twoCheckout: true
    }
  },

  {
    path: '/unlimited-paddle/',
    name: 'unlimitedPaddle.index',
    component: () => import('@/pages/CheckoutPages/UnlimitedV2/Index'),
    children: createUnlimitedChildren(true),
    meta: {
      ...CHECKOUT_META.unlimited,
      type: 'external_unlimited_paddle',
      paddle: true,
      paddleDiscount: '80'
    }
  },

  {
    path: '/unlimited-offer-update/',
    name: 'unlimitedOfferUpdate.index',
    component: () => import('@/pages/CheckoutPages/UnlimitedV2/Index'),
    children: [
      {
        path: '',
        name: 'unlimitedOfferUpdate.start',
        component: () => import('@/pages/CheckoutPages/UnlimitedV2/Start')
      },
      {
        path: 'registration/:offerId',
        name: 'unlimitedOfferUpdate.register',
        component: () =>
          import('@/pages/CheckoutPages/UnlimitedV2/Registration'),
        meta: {
          auth: false
        },
        beforeEnter(to, from, next) {
          const isAuth = store.getters['auth/isAuthenticated']
          if (isAuth) {
            return next('/unlimited-offer-update/')
          }
          next()
        }
      },
      {
        path: 'payment/:offerId',
        name: 'unlimitedOfferUpdate.payment',
        component: () => import('@/pages/CheckoutPages/UnlimitedV2/Payment')
      }
    ],
    meta: {
      type: 'external_unlimited_offer_update',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      twoCheckout: true,
      planGroup: 'unlimitedUpdate',
      discount: 70
    }
  },

  {
    path: '/unlimited-offer-welcome/',
    name: 'unlimitedWelcome.index',
    component: () => import('@/pages/CheckoutPages/UnlimitedV2/Index'),
    children: [
      {
        path: '',
        name: 'unlimitedWelcome.start',
        component: () => import('@/pages/CheckoutPages/UnlimitedV2/Start')
      },
      {
        path: 'registration/:offerId',
        name: 'unlimitedWelcome.register',
        component: () =>
          import('@/pages/CheckoutPages/UnlimitedV2/Registration'),
        meta: {
          auth: false
        },
        beforeEnter(to, from, next) {
          const isAuth = store.getters['auth/isAuthenticated']
          if (isAuth) {
            return next('/unlimited-offer-welcome/')
          }
          next()
        }
      },
      {
        path: 'payment/:offerId',
        name: 'unlimitedWelcome.payment',
        component: () => import('@/pages/CheckoutPages/UnlimitedV2/Payment')
      }
    ],
    meta: {
      type: 'external_unlimited_offer_welcome',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false
    }
  },

  {
    path: '/spring-sale/',
    name: 'springSale.index',
    component: () => import('@/pages/CheckoutPages/SpringSale/Index'),
    children: [
      {
        path: '',
        name: 'springSale.start',
        component: () => import('@/pages/CheckoutPages/SpringSale/Start')
      },
      {
        path: 'registration/:offerId',
        name: 'springSale.register',
        component: () =>
          import('@/pages/CheckoutPages/SpringSale/Registration'),
        meta: {
          auth: false
        },
        beforeEnter(to, from, next) {
          const isaAuth = store.getters['auth/isAuthenticated']
          if (isaAuth) {
            return next('/spring-sale/')
          }
          next()
        }
      },
      {
        path: 'payment/:offerId',
        name: 'springSale.payment',
        component: () => import('@/pages/CheckoutPages/SpringSale/Payment')
      }
    ],
    meta: {
      type: 'external_spring_sale',
      planGroup: '70',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false
    }
  },

  {
    path: '/spring-sale-marketing/',
    name: 'springSaleMarketing.index',
    component: () => import('@/pages/CheckoutPages/SpringSale/Index'),
    children: [
      {
        path: '',
        name: 'springSaleMarketing.start',
        component: () => import('@/pages/CheckoutPages/SpringSale/Start')
      },
      {
        path: 'registration/:offerId',
        name: 'springSaleMarketing.register',
        component: () =>
          import('@/pages/CheckoutPages/SpringSale/Registration'),
        meta: {
          auth: false
        },
        beforeEnter(to, from, next) {
          const isaAuth = store.getters['auth/isAuthenticated']
          if (isaAuth) {
            return next('/spring-sale-marketing/')
          }
          next()
        }
      },
      {
        path: 'payment/:offerId',
        name: 'springSaleMarketing.payment',
        component: () => import('@/pages/CheckoutPages/SpringSale/Payment')
      }
    ],
    meta: {
      type: 'external_spring_sale_marketing',
      planGroup: '70',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      customDiscount: 0.7
    }
  },

  {
    path: '/spring-sale-ab-control/',
    name: 'springSaleControl.index',
    component: () => import('@/pages/CheckoutPages/SpringSale/Index'),
    children: [
      {
        path: '',
        name: 'springSaleControl.start',
        component: () => import('@/pages/CheckoutPages/SpringSale/Start')
      },
      {
        path: 'registration/:offerId',
        name: 'springSaleControl.register',
        component: () =>
          import('@/pages/CheckoutPages/SpringSale/Registration'),
        meta: {
          auth: false
        },
        beforeEnter(to, from, next) {
          const isaAuth = store.getters['auth/isAuthenticated']
          if (isaAuth) {
            return next('/spring-sale-ab-control/')
          }
          next()
        }
      },
      {
        path: 'payment/:offerId',
        name: 'springSaleControl.payment',
        component: () => import('@/pages/CheckoutPages/SpringSale/Payment')
      }
    ],
    meta: {
      planGroup: '70',
      type: 'external_spring_sale_ab6070_control',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false
    }
  },
  {
    path: '/spring-sale-ab-test/',
    name: 'springGroupB.index',
    component: () => import('@/pages/CheckoutPages/SpringSale/Index'),
    children: [
      {
        path: '',
        name: 'springGroupB.start',
        component: () => import('@/pages/CheckoutPages/SpringSale/Start')
      },
      {
        path: 'registration/:offerId',
        name: 'springGroupB.register',
        component: () =>
          import('@/pages/CheckoutPages/SpringSale/Registration'),
        meta: {
          auth: false
        },
        beforeEnter(to, from, next) {
          const isaAuth = store.getters['auth/isAuthenticated']
          if (isaAuth) {
            return next('/spring-sale-ab-test/')
          }
          next()
        }
      },
      {
        path: 'payment/:offerId',
        name: 'springGroupB.payment',
        component: () => import('@/pages/CheckoutPages/SpringSale/Payment')
      }
    ],
    meta: {
      type: 'external_spring_sale_ab6070_groub_b',
      planGroup: '60',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false
    }
  },

  {
    path: '/spring-sale-web/',
    name: 'springSaleWeb.index',
    component: () => import('@/pages/CheckoutPages/SpringSaleWeb/Index'),
    children: [
      {
        path: '',
        name: 'springSaleWeb.start',
        component: () => import('@/pages/CheckoutPages/SpringSaleWeb/Start')
      },
      {
        path: 'registration/:offerId',
        name: 'springSaleWeb.register',
        component: () =>
          import('@/pages/CheckoutPages/SpringSaleWeb/Registration'),
        meta: {
          auth: false
        },
        beforeEnter(to, from, next) {
          const isaAuth = store.getters['auth/isAuthenticated']
          if (isaAuth) {
            return next('/spring-sale-web/')
          }
          next()
        }
      },
      {
        path: 'payment/:offerId',
        name: 'springSaleWeb.payment',
        component: () => import('@/pages/CheckoutPages/SpringSaleWeb/Payment')
      }
    ],
    meta: {
      type: 'external_spring_sale_web',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false
    }
  },

  {
    path: '/summer-sale-checkout/',
    name: 'summerSaleCheckout.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('summerSaleCheckout', '/summer-sale-checkout/'),
    meta: {
      type: 'external_summer_sale_checkout',
      planGroup: '50',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'summerSale',
      twoCheckout: true
    }
  },

  {
    path: '/summer-sale-2checkout-control/',
    name: 'summerSaleCheckoutControl.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren(
      'summerSaleCheckoutControl',
      '/summer-sale-2checkout-control/'
    ),
    meta: {
      type: 'external_summer_sale_2checkout_control',
      planGroup: '50',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'summerSale',
      twoCheckout: true
    }
  },

  {
    path: '/success/',
    name: 'success',
    component: () => import('@/pages/Checkout/Success'),
    meta: {
      auth: true
    }
  },

  {
    path: '/summer-sale-control/',
    name: 'summerSaleControl.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('summerSaleControl', '/summer-sale-control/'),
    meta: {
      type: 'external_summer_sale_control',
      planGroup: '70',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'summerSale'
    }
  },

  {
    path: '/summer-sale-test/',
    name: 'summerSaleTest.index',
    component: () => import('@/pages/CheckoutPages/SummerSale/Index'),
    children: [
      {
        path: '',
        name: 'summerSaleTest.start',
        component: () => import('@/pages/CheckoutPages/SummerSale/Start')
      },
      {
        path: 'registration/:offerId',
        name: 'summerSaleTest.register',
        component: () =>
          import('@/pages/CheckoutPages/SummerSale/Registration'),
        meta: {
          auth: false
        },
        beforeEnter(to, from, next) {
          const isaAuth = store.getters['auth/isAuthenticated']
          if (isaAuth) {
            return next('/summer-sale-test/')
          }
          next()
        }
      },
      {
        path: 'payment/:offerId',
        name: 'summerSaleTest.payment',
        component: () => import('@/pages/CheckoutPages/SummerSale/Payment')
      }
    ],
    meta: {
      type: 'external_summer_sale_test',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false
    }
  },

  {
    path: '/summer-sale/',
    name: 'summerSale.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('summerSale', '/summer-sale/'),
    meta: {
      type: 'external_summer_sale',
      planGroup: '50',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'summerSale'
    }
  },

  {
    path: '/summer-sale_6promo/',
    name: 'summerSalePromo.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('summerSalePromo', '/summer-sale_6promo/'),
    meta: {
      type: 'external_summer_sale_6promo',
      planGroup: '50',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'summerSale66'
    }
  },

  {
    path: '/summer_sale_6promo_2checkout/',
    name: 'summerSalePromoTwoCheckout.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren(
      'summerSalePromoTwoCheckout',
      '/summer-sale_6promo_2checkout/'
    ),
    meta: {
      type: 'external_summer_sale_6promo_2checkout',
      planGroup: '50',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'summerSale66',
      twoCheckout: true
    }
  },

  {
    path: '/summer-sale-internal-promo/',
    name: 'summerSaleInternalPromo.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren(
      'summerSaleInternalPromo',
      '/summer-sale-internal-promo/'
    ),
    meta: {
      type: 'external_summer_sale_internal_promo',
      planGroup: 'twoCheckoutPlans',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'summerSaleTest',
      twoCheckout: true
    }
  },

  {
    path: '/summer-sale_9_3/',
    name: 'summerSaleNinetyThree.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('summerSaleNinetyThree', '/summer-sale_9_3/'),
    meta: {
      type: 'external_summer_sale_9_3',
      planGroup: 'summerSaleNinetyThreePlans',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'summerSaleNinetyThree',
      twoCheckout: true
    }
  },
  {
    path: '/summer-sale_12_12/',
    name: 'summerSaleТwelve.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('summerSaleТwelve', '/summer-sale_12_12/'),
    meta: {
      type: 'external_summer_sale_12_12',
      planGroup: 'summerSaleТwelvePlans',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'summerSaleТwelve',
      twoCheckout: true
    }
  },

  {
    path: '/promo-sale-web/',
    name: 'promoSaleWeb.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('promoSaleWeb', '/promo-sale-web/'),
    meta: {
      type: 'external_promo_sale_web',
      planGroup: '70',
      experiment_layer: 'conversion',
      hasTrial: false,
      auth: false,
      theme: 'springSale70',
      twoCheckout: true,
      applePay: true
    }
  },

  {
    path: '/unlimited-black-friday/',
    name: 'unlimitedBlackFriday.index',
    component: () => import('@/pages/CheckoutPages/UnlimitedV2/Index'),
    children: [
      {
        path: '',
        name: 'unlimitedBlackFriday.start',
        component: () => import('@/pages/CheckoutPages/UnlimitedV2/Start')
      },
      {
        path: 'registration/:offerId',
        name: 'unlimitedBlackFriday.register',
        component: () =>
          import('@/pages/CheckoutPages/UnlimitedV2/Registration'),
        meta: {
          auth: false
        },
        beforeEnter(to, from, next) {
          const isAuth = store.getters['auth/isAuthenticated']
          if (isAuth) {
            return next('/unlimited-black-friday/')
          }
          next()
        }
      },
      {
        path: 'payment/:offerId',
        name: 'unlimitedBlackFriday.payment',
        component: () => import('@/pages/CheckoutPages/UnlimitedV2/Payment')
      }
    ],
    meta: {
      type: 'external_unlimited_black_friday',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      twoCheckout: true
    }
  },

  {
    path: '/new-year-70/',
    name: 'newYear70.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('newYear70', '/new-year-70/'),
    meta: {
      type: 'external_new_year_70',
      planGroup: '70',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'newYear70',
      twoCheckout: true
    }
  },

  {
    path: '/new-year-3-9-focus-2/',
    name: 'newYearFocus2.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('newYearFocus2', '/new-year-3-9-focus-2/'),
    meta: {
      type: 'external_new_year_3_9_focus_2',
      planGroup: 'seventyAndThreePlusSix',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'newYearFocus2',
      twoCheckout: true
    }
  },

  {
    path: '/new-year-3-9/',
    name: 'newYear39.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('newYear39', '/new-year-3-9/'),
    meta: {
      type: 'external_new_year_3_9',
      planGroup: 'seventyAndThreePlusSix',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'newYear39',
      twoCheckout: true
    }
  },

  {
    path: '/new-year-sale-6-6/',
    name: 'newYearSale66.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('newYearSale66', '/new-year-sale-6-6/'),
    meta: {
      type: 'external_new_year_sale_6_6',
      planGroup: 'sixPlusSix',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'newYearSale66',
      twoCheckout: true
    }
  },

  {
    path: '/new-year-12-12/',
    name: 'newYear24.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('newYear24', '/new-year-12-12/'),
    meta: {
      type: 'external_new_year_12_12',
      planGroup: 'twelvePlusTwelve',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'newYear24',
      twoCheckout: true
    }
  },

  {
    path: '/new-year-sale-6-6-one-offer/',
    name: 'autumnSale66OneOffer.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren(
      'autumnSale66OneOffer',
      '/new-year-sale-6-6-one-offer/'
    ),
    meta: {
      type: 'external_new_year_sale_6_6_one_offer',
      planGroup: '50',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'newYearSale66',
      twoCheckout: true
    }
  },

  {
    path: '/new-year-focus-month/',
    name: 'newYearFocusMonth.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('newYearFocusMonth', '/new-year-focus-month/'),
    meta: {
      type: 'external_new_year_focus_month',
      planGroup: 'autumnSaleYearMonthPlans',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'newYear39',
      twoCheckout: true
    }
  },

  {
    path: '/new-year-social-3-9/',
    name: 'newYearSocial39.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('newYearSocial39', '/new-year-social-3-9/'),
    meta: {
      type: 'external_new_year_social_3_9',
      planGroup: 'seventyAndThreePlusSix',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'newYear39',
      withTierSupport: true,
      twoCheckout: true,
      applePay: true
    }
  },

  {
    path: '/paywall-v2m-v1/',
    name: 'paywallV2.index',
    component: () => import('@/pages/CheckoutPages/PaywallV2/Index'),
    children: [
      {
        path: '',
        name: 'paywallV2.start',
        component: () => import('@/pages/CheckoutPages/PaywallV2/Start')
      },
      {
        path: 'payment/:offerId',
        name: 'paywallV2.payment',
        component: () => import('@/pages/CheckoutPages/PaywallV2/Payment')
      }
    ],
    meta: {
      experiment_layer: 'external',
      hasTrial: false,
      auth: true
    }
  },

  {
    path: '/paywall-promo-v2m-v1',
    name: 'paywallPromoV2.index',
    component: () => import('@/pages/CheckoutPages/PaywallPromoV2/Index'),
    children: [
      {
        path: '',
        name: 'paywallPromoV2.start',
        component: () => import('@/pages/CheckoutPages/PaywallPromoV2/Start')
      },
      {
        path: 'payment/:offerId',
        name: 'paywallPromoV2.payment',
        component: () => import('@/pages/CheckoutPages/PaywallPromoV2/Payment')
      }
    ],
    meta: {
      experiment_layer: 'external',
      hasTrial: false,
      auth: true
    }
  },

  {
    path: '/paywall-success-v1',
    name: 'paywallSuccess.index',
    component: () => import('@/pages/CheckoutPages/PaywallV2/Success'),
    meta: {
      auth: true
    }
  },

  {
    path: '/paywall-download-v1',
    name: 'paywallDownload.index',
    component: () => import('@/pages/CheckoutPages/PaywallV2/Download'),
    meta: {
      auth: true
    }
  },

  {
    path: '/winter-sale-one-3-9/',
    name: 'winterSaleOne39.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('winterSaleOne39', '/winter-sale-one-3-9/'),
    meta: {
      type: 'external_winter_sale_one_offer_3_9',
      planGroup: 'seventyAndThreePlusSix',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'winterSaleOne39',
      twoCheckout: true
    }
  },

  {
    path: '/winter-6-6/',
    name: 'winter66.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('winter66', '/winter-6-6/'),
    meta: {
      type: 'external_winter_sale_6_6',
      planGroup: 'crmPagesTierExperiment66',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'winter66',
      withTierSupport: true,
      paddle: true,
      paddleDiscount: '50'
    }
  },

  {
    path: '/winter-3-9/',
    name: 'winter39.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('winter39', '/winter-3-9/'),
    meta: {
      type: 'external_winter_sale_3_9',
      planGroup: 'crmPagesTierExperiment39',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'winter39',
      withTierSupport: true,
      paddle: true,
      paddleDiscount: '75'
    }
  },

  {
    path: '/winter-12-12/',
    name: 'winter24.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('winter24', '/winter-12-12/'),
    meta: {
      type: 'external_winter_sale_12_12',
      planGroup: 'crmPagesTierExperiment24',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'winter24',
      withTierSupport: true,
      paddle: true,
      paddleDiscount: '50'
    }
  },

  {
    path: '/winter-70/',
    name: 'winter70.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('winter70', '/winter-70/'),
    meta: {
      type: 'external_winter_sale_70',
      planGroup: 'crmPagesTierExperiment39',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'winter70',
      withTierSupport: true,
      paddle: true,
      paddleDiscount: '70'
    }
  },

  {
    path: '/winter-social-6-6/',
    name: 'winterSocial66.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('winterSocial66', '/winter-social-6-6/'),
    meta: {
      type: 'external_winter_6_6_social',
      planGroup: 'sixPlusSix',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'winter66',
      withTierSupport: true,
      twoCheckout: true,
      applePay: true
    }
  },

  {
    path: '/winter-social-3-9/',
    name: 'winterSocial39.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('winterSocial39', '/winter-social-3-9/'),
    meta: {
      type: 'external_winter_3_9_social',
      planGroup: 'seventyAndThreePlusSix',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'winter39',
      withTierSupport: true,
      twoCheckout: true,
      applePay: true
    }
  },

  {
    path: '/winter-sale-80/',
    name: 'winterSale80.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('winterSale80', '/winter-sale-80/'),
    meta: {
      type: 'external_winter_sale_80',
      planGroup: '70',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'winterSale80',
      twoCheckout: true
    }
  },
  {
    path: '/spring-sale-3-9/',
    name: 'springSale39.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('springSale39', '/spring-sale-3-9/'),
    meta: {
      type: 'external_spring_sale_3_9',
      planGroup: 'crmPagesTierExperiment39',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'springSale39',
      paddle: true,
      paddleDiscount: '75',
      applePay: true
    }
  },

  {
    path: '/spring-sale-3-9-checkout-test/',
    name: 'springSale39CheckoutTest.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren(
      'springSale39CheckoutTest',
      '/spring-sale-3-9-checkout-test/'
    ),
    meta: {
      type: 'external_spring_3_9_checkout_test',
      planGroup: 'seventyAndThreePlusSix',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'springSale39',
      twoCheckout: true,
      checkoutType: 'convertPlus'
    }
  },

  {
    path: '/spring-sale-3-9-checkout-control/',
    name: 'springSale39CheckoutControl.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren(
      'springSale39CheckoutControl',
      '/spring-sale-3-9-checkout-control/'
    ),
    meta: {
      type: 'external_spring_3_9_checkout_control',
      planGroup: 'seventyAndThreePlusSix',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'springSale39',
      twoCheckout: true,
      applePay: true,
      orderStyle: 'nLWwnZWpmHI='
    }
  },

  {
    path: '/spring-sale-70/',
    name: 'springSale70.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('springSale70', '/spring-sale-70/'),
    meta: {
      type: 'external_spring_sale_70',
      planGroup: 'crmPagesTierExperiment39',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'springSale70',
      paddle: true,
      applePay: true,
      paddleDiscount: '70'
    }
  },
  {
    path: '/spring-sale-6-6/',
    name: 'springSale66.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('springSale66', '/spring-sale-6-6/'),
    meta: {
      type: 'external_spring_sale_6_6',
      planGroup: 'crmPagesTierExperiment66',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'springSale66',
      paddle: true,
      applePay: true,
      paddleDiscount: '50'
    }
  },

  {
    path: '/spring-sale-12-12/',
    name: 'springSale24.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('springSale24', '/spring-sale-12-12/'),
    meta: {
      type: 'external_spring_sale_12_12',
      planGroup: 'crmPagesTierExperiment24',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'springSale24',
      paddle: true,
      applePay: true,
      paddleDiscount: '50'
    }
  },

  {
    path: '/spring-sale-50',
    name: 'springSale50.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('springSale50', '/spring-sale-50/'),
    meta: {
      type: 'external_spring_sale_50',
      planGroup: '50',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'springSale50',
      twoCheckout: true,
      applePay: true
    }
  },

  {
    path: '/spring-sale-social-6-6/',
    name: 'springSaleSocial66.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('springSaleSocial66', '/spring-sale-social-6-6/'),
    meta: {
      type: 'external_spring_sale_6_6_social',
      planGroup: 'sixPlusSix',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'springSale66',
      withTierSupport: true,
      twoCheckout: true,
      applePay: true
    }
  },

  {
    path: '/spring-sale-social-3-9/',
    name: 'springSaleSocial39.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('springSaleSocial39', '/spring-sale-social-3-9/'),
    meta: {
      type: 'external_spring_sale_3_9_social',
      planGroup: 'seventyAndThreePlusSix',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'springSale39',
      withTierSupport: true,
      twoCheckout: true,
      applePay: true
    }
  },

  {
    path: '/spring-sale-12-12-checkout-test/',
    name: 'springSale24CheckoutTest.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren(
      'springSale24CheckoutTest',
      '/spring-sale-12-12-checkout-test/'
    ),
    meta: {
      type: 'external_spring_12_12_checkout_test',
      planGroup: 'springSale24',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'springSale24',
      twoCheckout: true,
      checkoutType: 'convertPlus'
    }
  },

  {
    path: '/onboarding-promo-6-6/',
    name: 'onboardinPromo66.index',
    component: () => import('@/pages/CheckoutPages/OnboardingPromo/Index'),
    children: [
      {
        path: '',
        name: 'onboardinPromo66.start',
        component: () => import('@/pages/CheckoutPages/OnboardingPromo/Start')
      },
      {
        path: 'registration/:offerId',
        name: 'onboardinPromo66.register',
        component: () => import('@/pages/CheckoutPages/layouts/Registration'),
        meta: {
          auth: false
        },
        beforeEnter(to, from, next) {
          const isAuth = store.getters['auth/isAuthenticated']
          if (isAuth) {
            return next('/onboarding-promo-6-6/')
          }
          next()
        }
      },
      {
        path: 'payment/:offerId',
        name: 'onboardinPromo66.payment',
        component: () => import('@/pages/CheckoutPages/layouts/Payment')
      }
    ],
    meta: {
      type: 'external_onboarding_promo_6_6',
      planGroup: 'sixPlusSix',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      twoCheckout: true,
      applePay: true
    }
  },

  {
    path: '/onboarding-promo-70/',
    name: 'onboardinPromo70.index',
    component: () => import('@/pages/CheckoutPages/OnboardingPromo/Index'),
    children: [
      {
        path: '',
        name: 'onboardinPromo70.start',
        component: () => import('@/pages/CheckoutPages/OnboardingPromo/Start')
      },
      {
        path: 'registration/:offerId',
        name: 'onboardinPromo70.register',
        component: () => import('@/pages/CheckoutPages/layouts/Registration'),
        meta: {
          auth: false
        },
        beforeEnter(to, from, next) {
          const isAuth = store.getters['auth/isAuthenticated']
          if (isAuth) {
            return next('/onboarding-promo-70/')
          }
          next()
        }
      },
      {
        path: 'payment/:offerId',
        name: 'onboardinPromo70.payment',
        component: () => import('@/pages/CheckoutPages/layouts/Payment')
      }
    ],
    meta: {
      type: 'external_onboarding_promo_70',
      planGroup: 'promoNoTrial70Plans',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      twoCheckout: true,
      applePay: true
    }
  },

  {
    path: '/onboarding-promo-12-12/',
    name: 'onboardinPromo12.index',
    component: () => import('@/pages/CheckoutPages/OnboardingPromo/Index'),
    children: [
      {
        path: '',
        name: 'onboardinPromo12.start',
        component: () => import('@/pages/CheckoutPages/OnboardingPromo/Start')
      },
      {
        path: 'registration/:offerId',
        name: 'onboardinPromo12.register',
        component: () => import('@/pages/CheckoutPages/layouts/Registration'),
        meta: {
          auth: false
        },
        beforeEnter(to, from, next) {
          const isAuth = store.getters['auth/isAuthenticated']
          if (isAuth) {
            return next('/onboarding-promo-12-12/')
          }
          next()
        }
      },
      {
        path: 'payment/:offerId',
        name: 'onboardinPromo12.payment',
        component: () => import('@/pages/CheckoutPages/layouts/Payment')
      }
    ],
    meta: {
      type: 'external_onboarding_promo_12_12',
      planGroup: 'twelvePlusTwelve',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      twoCheckout: true,
      applePay: true
    }
  },

  {
    path: '/onboarding-promo-3-9',
    name: 'onboardinPromo39.index',
    component: () => import('@/pages/CheckoutPages/OnboardingPromo/Index'),
    children: [
      {
        path: '',
        name: 'onboardinPromo39.start',
        component: () => import('@/pages/CheckoutPages/OnboardingPromo/Start')
      },
      {
        path: 'registration/:offerId',
        name: 'onboardinPromo39.register',
        component: () => import('@/pages/CheckoutPages/layouts/Registration'),
        meta: {
          auth: false
        },
        beforeEnter(to, from, next) {
          const isAuth = store.getters['auth/isAuthenticated']
          if (isAuth) {
            return next('/onboarding-promo-3-9')
          }
          next()
        }
      },
      {
        path: 'payment/:offerId',
        name: 'onboardinPromo39.payment',
        component: () => import('@/pages/CheckoutPages/layouts/Payment')
      }
    ],
    meta: {
      type: 'external_onboarding_promo_3_9',
      planGroup: 'seventyAndThreePlusSix',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      twoCheckout: true,
      applePay: true
    }
  },

  {
    path: '/spring-sale-6-6-checkout-test/',
    name: 'springSale66CheckoutTest.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren(
      'springSale39CheckoutTest',
      '/spring-sale-6-6-checkout-test/'
    ),
    meta: {
      type: 'external_spring_6_6_checkout_test',
      planGroup: 'sixPlusSix',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'springSale66',
      twoCheckout: true,
      checkoutType: 'convertPlus'
    }
  },

  {
    path: '/spring-sale-6-6-checkout-control/',
    name: 'springSale66CheckoutControl.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren(
      'springSale66CheckoutControl',
      '/spring-sale-6-6-checkout-control/'
    ),
    meta: {
      type: 'external_spring_6_6_checkout_control',
      planGroup: 'sixPlusSix',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'springSale66',
      twoCheckout: true,
      applePay: true,
      orderStyle: 'nLWwnZWpmHI='
    }
  },

  {
    path: '/spring-sale-12-12-checkout-control/',
    name: 'springSale24CheckoutControl.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren(
      'springSale24CheckoutControl',
      '/spring-sale-12-12-checkout-control/'
    ),
    meta: {
      type: 'external_spring_12_12_checkout_control',
      planGroup: 'springSale24',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'springSale24',
      twoCheckout: true,
      applePay: true,
      orderStyle: 'nLWwnZWpmHI='
    }
  },

  {
    path: '/summer-3-9-control/',
    name: 'summerControl39.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('summerControl39', '/summer-3-9-control/'),
    meta: {
      ...CHECKOUT_META['summer-3-9'],
      type: 'external_summer_sale_3_9_control',
      twoCheckout: true
    }
  },

  {
    path: '/summer-3-9-new/',
    name: 'summerNew39.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('summerNew39', '/summer-3-9-new/'),
    meta: {
      ...CHECKOUT_META['summer-3-9'],
      type: 'external_summer_sale_3_9_new',
      paddle: true,
      paddleDiscount: '75'
    }
  },

  {
    path: '/summer-3-9-social/',
    name: 'summerSocial39.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('summerSocial39', '/summer-3-9-social/'),
    meta: {
      ...CHECKOUT_META['summer-3-9'],
      type: 'external_summer_sale_3_9_social',
      paddle: true,
      paddleDiscount: '75',
      withTierSupport: true
    }
  },

  {
    path: '/summer-70-control/',
    name: 'summerControl70.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('summerControl70', '/summer-70-control/'),
    meta: {
      ...CHECKOUT_META['summer-70'],
      type: 'external_summer_sale_70_control',
      twoCheckout: true
    }
  },

  {
    path: '/summer-70-new/',
    name: 'summerNew70.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('summerNew70', '/summer-70-new/'),
    meta: {
      ...CHECKOUT_META['summer-70'],
      type: 'external_summer_sale_70_new',
      paddle: true
    }
  },

  {
    path: '/summer-70-social/',
    name: 'summerSocial70.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('summerSocial70', '/summer-70-social/'),
    meta: {
      ...CHECKOUT_META['summer-70'],
      type: 'external_summer_sale_70_social',
      paddle: true,
      withTierSupport: true
    }
  },

  {
    path: '/summer-6-6-control/',
    name: 'summerControl66.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('summerControl66', '/summer-6-6-control/'),
    meta: {
      ...CHECKOUT_META['summer-6-6'],
      type: 'external_summer_sale_6_6_control',
      twoCheckout: true
    }
  },

  {
    path: '/summer-6-6-new/',
    name: 'summerNew66.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('summerNew66', '/summer-6-6-new/'),
    meta: {
      ...CHECKOUT_META['summer-6-6'],
      type: 'external_summer_sale_6_6_new',
      paddle: true,
      paddleDiscount: '50'
    }
  },

  {
    path: '/summer-12-12-control/',
    name: 'summerControl24.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('summerControl24', '/summer-12-12-control/'),
    meta: {
      ...CHECKOUT_META['summer-12-12'],
      type: 'external_summer_sale_12_12_control',
      twoCheckout: true
    }
  },

  {
    path: '/summer-12-12-new/',
    name: 'summerNew24.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('summerNew24', '/summer-12-12-new/'),
    meta: {
      ...CHECKOUT_META['summer-12-12'],
      type: 'external_summer_sale_12_12_new',
      paddle: true,
      paddleDiscount: '50'
    }
  },

  {
    path: '/summer-sale-3-9/',
    name: 'summerSale39.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('summerSale39', '/summer-sale-3-9/'),
    meta: {
      type: 'external_summer_sale_3_9',
      planGroup: 'seventyAndThreePlusSix',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'summerSale39',
      twoCheckout: true,
      applePay: true,
      checkoutType: 'convertPlus'
    }
  },

  {
    path: '/summer-sale-70/',
    name: 'summerSale70.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('summerSale70', '/summer-sale-70/'),
    meta: {
      type: 'external_summer_sale_70',
      planGroup: 'seventyAndThreePlusSix',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'summerSale70',
      twoCheckout: true,
      applePay: true,
      checkoutType: 'convertPlus'
    }
  },

  {
    path: '/summer-sale-12-12/',
    name: 'summerSale24.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('summerSale24', '/summer-sale-12-12/'),
    meta: {
      type: 'external_summer_sale_12_12',
      planGroup: 'summerSale24',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'summerSale24',
      twoCheckout: true,
      applePay: true,
      checkoutType: 'convertPlus'
    }
  },

  {
    path: '/summer-sale-6-6/',
    name: 'summerSale66.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('summerSale66', '/summer-sale-6-6/'),
    meta: {
      type: 'external_summer_sale_6_6',
      planGroup: 'sixPlusSix',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'summerSale66New',
      twoCheckout: true,
      applePay: true,
      checkoutType: 'convertPlus'
    }
  },

  {
    path: '/summer-sale-social-6-6/',
    name: 'summerSaleSocial66.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('summerSaleSocial66', '/summer-sale-social-6-6/'),
    meta: {
      type: 'external_summer_sale_6_6_social',
      planGroup: 'sixPlusSix',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'summerSale66New',
      withTierSupport: true,
      twoCheckout: true,
      applePay: true
    }
  },

  {
    path: '/onboarding-6-6/',
    name: 'onboarding66.index',
    component: () => import('@/pages/CheckoutPages/Onboarding/Index'),
    children: createOnboardingChildren('onboarding-6-6'),
    meta: {
      ...CHECKOUT_META['onboarding-6-6'],
      type: 'external_onboarding_promo_6_6_test',
      twoCheckout: true
    }
  },

  {
    path: '/onboarding-6-6-new/',
    name: 'onboarding66New.index',
    component: () => import('@/pages/CheckoutPages/Onboarding/Index'),
    children: createOnboardingChildren('onboarding-6-6', true),
    meta: {
      ...CHECKOUT_META['onboarding-6-6'],
      type: 'external_onboarding_promo_6_6_new',
      paddle: true,
      paddleDiscount: '50'
    }
  },

  {
    path: '/onboarding-3-9',
    name: 'onboarding39.index',
    component: () => import('@/pages/CheckoutPages/Onboarding/Index'),
    children: createOnboardingChildren('onboarding-3-9'),
    meta: {
      ...CHECKOUT_META['onboarding-3-9'],
      type: 'external_onboarding_promo_3_9_test',
      twoCheckout: true
    }
  },

  {
    path: '/onboarding-3-9-new/',
    name: 'onboarding39New.index',
    component: () => import('@/pages/CheckoutPages/Onboarding/Index'),
    children: createOnboardingChildren('onboarding-3-9', true),
    meta: {
      ...CHECKOUT_META['onboarding-3-9'],
      type: 'external_onboarding_promo_3_9_new',
      paddle: true,
      paddleDiscount: '75'
    }
  },

  {
    path: '/onboarding-70/',
    name: 'onboarding70.index',
    component: () => import('@/pages/CheckoutPages/Onboarding/Index'),
    children: createOnboardingChildren('onboarding-70'),
    meta: {
      ...CHECKOUT_META['onboarding-70'],
      type: 'external_onboarding_promo_70_test',
      twoCheckout: true
    }
  },

  {
    path: '/onboarding-70-new/',
    name: 'onboarding70New.index',
    component: () => import('@/pages/CheckoutPages/Onboarding/Index'),
    children: createOnboardingChildren('onboarding-70', true),
    meta: {
      ...CHECKOUT_META['onboarding-70'],
      type: 'external_onboarding_promo_70_new',
      paddle: true,
      paddleDiscount: '70'
    }
  },

  {
    path: '/onboarding-12-12/',
    name: 'onboarding12.index',
    component: () => import('@/pages/CheckoutPages/Onboarding/Index'),
    children: createOnboardingChildren('onboarding-12-12'),
    meta: {
      ...CHECKOUT_META['onboarding-12-12'],
      type: 'external_onboarding_promo_12_12_test',
      twoCheckout: true
    }
  },

  {
    path: '/onboarding-12-12-new/',
    name: 'onboarding12New.index',
    component: () => import('@/pages/CheckoutPages/Onboarding/Index'),
    children: createOnboardingChildren('onboarding-12-12', true),
    meta: {
      ...CHECKOUT_META['onboarding-12-12'],
      type: 'external_onboarding_promo_12_12_new',
      paddle: true,
      paddleDiscount: '50'
    }
  },

  {
    path: '/autumn-3-9/',
    name: 'autumnSale39.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('autumnSale39', '/autumn-3-9/'),
    meta: {
      ...CHECKOUT_META['autumn-3-9'],
      type: 'external_autumn_sale_3_9',
      twoCheckout: true
    }
  },
  {
    path: '/autumn-3-9-new/',
    name: 'autumnSale39New.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('autumnSale39New', '/autumn-3-9-new/'),
    meta: {
      ...CHECKOUT_META['autumn-3-9'],
      type: 'external_autumn_sale_3_9_new',
      paddle: true,
      paddleDiscount: '75'
    }
  },
  {
    path: '/autumn-3-9-social/',
    name: 'autumnSale39Social.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('autumnSale39Social', '/autumn-3-9-social/'),
    meta: {
      ...CHECKOUT_META['autumn-3-9'],
      type: 'external_autumn_sale_3_9_social',
      paddle: true,
      paddleDiscount: '75',
      withTierSupport: true
    }
  },
  {
    path: '/autumn-70/',
    name: 'autumnSale70.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('autumnSale70', '/autumn-70/'),
    meta: {
      ...CHECKOUT_META['autumn-70'],
      type: 'external_autumn_sale_70',
      twoCheckout: true
    }
  },
  {
    path: '/autumn-70-new/',
    name: 'autumnSale70New.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('autumnSale70New', '/autumn-70-new/'),
    meta: {
      ...CHECKOUT_META['autumn-70'],
      type: 'external_autumn_sale_70_new',
      paddle: true
    }
  },
  {
    path: '/autumn-70-social/',
    name: 'autumnSale70Social.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('autumnSale70Social', '/autumn-70-social/'),
    meta: {
      ...CHECKOUT_META['autumn-70'],
      type: 'external_autumn_sale_70_social',
      paddle: true,
      withTierSupport: true
    }
  },
  {
    path: '/autumn-6-6/',
    name: 'autumnSale66.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('autumnSale66', '/autumn-6-6/'),
    meta: {
      ...CHECKOUT_META['autumn-6-6'],
      type: 'external_autumn_sale_6_6',
      twoCheckout: true
    }
  },
  {
    path: '/autumn-6-6-new/',
    name: 'autumnSale66New.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('autumnSale66New', '/autumn-6-6-new/'),
    meta: {
      ...CHECKOUT_META['autumn-6-6'],
      type: 'external_autumn_sale_6_6_new',
      paddle: true,
      paddleDiscount: '50'
    }
  },
  {
    path: '/autumn-12-12/',
    name: 'autumnSale1212.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('autumnSale1212', '/autumn-12-12/'),
    meta: {
      ...CHECKOUT_META['autumn-12-12'],
      type: 'external_autumn_sale_12_12',
      twoCheckout: true
    }
  },
  {
    path: '/autumn-12-12-new/',
    name: 'autumnSale1212New.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('autumnSale1212New', '/autumn-12-12-new/'),
    meta: {
      ...CHECKOUT_META['autumn-12-12'],
      type: 'external_autumn_sale_12_12_new',
      paddle: true,
      paddleDiscount: '50'
    }
  },
  {
    path: '/autumn-sale-social-6-6/',
    name: 'autumnSaleSocial66.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('autumnSaleSocial66', '/autumn-sale-social-6-6/'),
    meta: {
      type: 'external_autumn_sale_6_6_social',
      planGroup: 'sixPlusSix',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'autumnSale66',
      withTierSupport: true,
      twoCheckout: true,
      applePay: true
    }
  },
  {
    path: '/autumn-sale-social-3-9/',
    name: 'autumnSaleSocial39.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('autumnSaleSocial39', '/autumn-sale-social-3-9/'),
    meta: {
      type: 'external_autumn_sale_3_9_social',
      planGroup: 'seventyAndThreePlusSix',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'autumnSale39',
      withTierSupport: true,
      twoCheckout: true,
      applePay: true
    }
  },
  {
    path: '/blackfriday-3-9/',
    name: 'blackFriday39.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('blackFriday39', '/blackfriday-3-9/'),
    meta: {
      type: 'external_blackfriday_sale_3_9',
      planGroup: 'seventyAndThreePlusSix',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'blackFriday39',
      withTierSupport: true,
      paddle: true,
      applePay: true,
      paddleDiscount: '75'
    }
  },
  {
    path: '/blackfriday-70/',
    name: 'blackFriday70.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('blackFriday70', '/blackfriday-70/'),
    meta: {
      type: 'external_blackfriday_sale_70',
      planGroup: 'seventyAndThreePlusSix',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'blackFriday70',
      withTierSupport: true,
      paddle: true,
      applePay: true,
      paddleDiscount: '75'
    }
  },
  {
    path: '/blackfriday-6-6/',
    name: 'blackFriday66.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('blackFriday66', '/blackfriday-6-6/'),
    meta: {
      type: 'external_blackfriday_sale_6_6',
      planGroup: 'sixPlusSix',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'blackFriday66',
      withTierSupport: true,
      paddle: true,
      applePay: true,
      paddleDiscount: '50'
    }
  },
  {
    path: '/blackfriday-12-12/',
    name: 'blackFriday24.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('blackFriday24', '/blackfriday-12-12/'),
    meta: {
      type: 'external_blackfriday_sale_12_12',
      planGroup: 'twelvePlusTwelve',
      hasTrial: false,
      auth: false,
      theme: 'blackFriday24',
      withTierSupport: true,
      paddle: true,
      applePay: true,
      paddleDiscount: '50'
    }
  },
  {
    path: '/blackfriday-social-3-9/',
    name: 'blackFridaySocial39.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('blackFridaySocial39', '/blackfriday-social-3-9/'),
    meta: {
      type: 'external_blackfriday_3_9_social',
      planGroup: 'seventyAndThreePlusSix',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'blackFriday39',
      withTierSupport: true,
      twoCheckout: true,
      applePay: true
    }
  },
  {
    path: '/blackfriday-social-6-6/',
    name: 'blackFridaySocial66.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('blackFridaySocial66', '/blackfriday-social-6-6/'),
    meta: {
      type: 'external_blackfriday_6_6_social',
      planGroup: 'sixPlusSix',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      theme: 'blackFriday66',
      withTierSupport: true,
      twoCheckout: true,
      applePay: true
    }
  },

  {
    path: '/unlimited-90/',
    name: 'unlimited90.index',
    component: () => import('@/pages/CheckoutPages/UnlimitedV2/Index'),
    children: [
      {
        path: '',
        name: 'unlimited90.start',
        component: () => import('@/pages/CheckoutPages/UnlimitedV2/Start')
      },
      {
        path: 'registration/:offerId',
        name: 'unlimited90.register',
        component: () =>
          import('@/pages/CheckoutPages/UnlimitedV2/Registration'),
        meta: {
          auth: false
        },
        beforeEnter(to, from, next) {
          const isAuth = store.getters['auth/isAuthenticated']
          if (isAuth) {
            return next('/unlimited-90/')
          }
          next()
        }
      },
      {
        path: 'payment/:offerId',
        name: 'unlimited90.payment',
        component: () => import('@/pages/CheckoutPages/UnlimitedV2/Payment')
      }
    ],
    meta: {
      type: 'external_unlimited_90',
      experiment_layer: 'external',
      hasTrial: false,
      auth: false,
      paddle: true,
      discount: 90,
      paddleDiscount: '90',
      withTierSupport: true
    }
  },

  {
    path: '/winter-80/',
    name: 'winter80.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('winter80', '/winter-80/'),
    meta: {
      type: 'external_winter_sale_80',
      planGroup: 'winterSale80',
      experiment_layer: 'conversion',
      hasTrial: false,
      auth: false,
      theme: 'winter80',
      twoCheckout: true,
      applePay: true,
      withTierSupport: true
    }
  },

  {
    path: '/winter-90/',
    name: 'winter90.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('winter90', '/winter-90/'),
    meta: {
      type: 'external_winter_sale_90',
      planGroup: 'winterSale80',
      experiment_layer: 'conversion',
      hasTrial: false,
      auth: false,
      theme: 'winter90',
      twoCheckout: true,
      applePay: true,
      withTierSupport: true
    }
  },

  {
    path: '/winter-real-90/',
    name: 'winterReal90.index',
    component: () => import('@/pages/CheckoutPages/layouts/Index'),
    children: createChildren('winterReal90', '/winter-real-90/'),
    meta: {
      type: 'external_winter_sale_real_90',
      planGroup: 'winterSale90',
      experiment_layer: 'conversion',
      hasTrial: false,
      auth: false,
      theme: 'winter90',
      twoCheckout: true,
      applePay: true,
      withTierSupport: true
    }
  }
].map(route => ({
  ...route,
  meta: {
    ...(route.meta || {}),
    allowSessionAuth: true
  }
}))
